/* eslint-disable custom-rules/require-data-test-id */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Grid, Grow, Typography } from '@material-ui/core'
import { ReactComponent as Logo } from '../../images/logo/symbol.svg'
import useStyles from './styles'

import { ADD_ON_BUILDER_CONTEXT } from '../../constants/App'

import LogoutRedirect from './components/LogoutRedirect'
import IntlText from '../IntlText'

export default function Preloader({
    renderLogoOnly,
    isLogout,
    disableTypographyAnimation,
    location,
    isRedirecting,
    showAsFixed,
    dataTestId
}) {
    const classes = useStyles()

    const queryParams = location && new URLSearchParams(location)
    const context = queryParams && queryParams.get('context')
    const isPopUpEditor = context === ADD_ON_BUILDER_CONTEXT

    return (
        <Grid
            className={classNames(
                classes.root,
                showAsFixed && classes.fixedRoot
            )}
            data-testid={dataTestId || 'Preloader-index'}
            alignItems="center"
            justifyContent="center"
            direction="column"
            wrap="nowrap"
            container
        >
            <Logo className={classes.logo} />
            <Grow in={!renderLogoOnly} timeout={{ appear: 0, enter: disableTypographyAnimation ? 0 : 150, exit: 0 }}>
                <Typography
                    className={classNames(
                        classes.description,
                        renderLogoOnly && classes.hiddenDescription,
                        isRedirecting && classes.textCentered
                    )}
                    variant="h5"
                >
                    {renderLogoOnly ? (
                        <>
                            {/**
                              * A text is required to maintain Typography element height, but Intl is not available
                              * when rendering in the app upper level. For accessibility, the default text is in English.
                              */}
                            Please wait
                        </>
                    ) : isPopUpEditor ? (
                        <IntlText id="general.loading.editor" />
                    ) : isLogout ? (
                        <IntlText id="general.signingOut" />
                    ) : isRedirecting ? (
                        <IntlText id="general.redirecting" />
                    ) : (
                        <IntlText id="general.loading.app" />
                    )}
                </Typography>
            </Grow>
            {location && (
                <Typography variant="caption">
                    {location}
                </Typography>
            )}
            {isLogout && (
                <LogoutRedirect />
            )}
        </Grid>
    )
}

Preloader.propTypes = {
    isLogout: PropTypes.bool,
    renderLogoOnly: PropTypes.bool,
    disableTypographyAnimation: PropTypes.bool,
    location: PropTypes.string,
    isRedirecting: PropTypes.bool,
    showAsFixed: PropTypes.bool,
    dataTestId: PropTypes.string
}

Preloader.defaultProps = {
    isLogout: false,
    renderLogoOnly: false,
    disableTypographyAnimation: false,
    location: '',
    isRedirecting: false,
    showAsFixed: false,
    dataTestId: null
}
